<div class="mv-field-container">
  <div class="bar"></div>
  <div class="fields">
    @for (control of formControls; track control) {
      <app-field
        [form-control]="control"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (keyup.enter)="onAddMultiValue({ append: true }, control, false)"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-field>
      <app-multi-value-field-menu
        #mvFieldMenu
        (addMultiValue)="onAddMultiValue($event, control, true)"
        (removeMultiValue)="onRemoveMultiValue(control)"
      ></app-multi-value-field-menu>
    }
  </div>
</div>
